export default {
	lang: 'en',
};
